// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========  Checkbox / Radio  ============= */
.FF_PreviewFields_checkbox_eYWMz,
.FF_PreviewFields_radio_YRSyy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.FF_PreviewFields_checkboxGroup_C1uVH,
.FF_PreviewFields_radioGroup_5gJMz {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  align-items: stretch;
}
/* Horizontal layout behavior:
   - 2 columns when there is room
   - 1 column as soon as 2-up can't fit (min-width forces wrap)
   - never becomes 3+ columns (basis is 50%)
*/
.FF_PreviewFields_checkboxGroup__isHorizontal_fcAfz .FF_PreviewFields_checkboxItem_ur-wF,
.FF_PreviewFields_radioGroup__isHorizontal_spbRz .FF_PreviewFields_radioItem_R\\+fJC {
  flex: 1 1 calc(50% - 0.25rem); /* 2 columns with a 0.5rem gap */
  min-width: 16.25rem;
  max-width: 100%;
}
/* Make sure the items can actually shrink/grow inside the flex row */
.FF_PreviewFields_checkboxItem_ur-wF,
.FF_PreviewFields_radioItem_R\\+fJC {
  min-width: 0;
}
.FF_PreviewFields_radioItem_R\\+fJC {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: min-content;
  width: auto;
}
.FF_PreviewFields_checkboxItem_ur-wF {
  display: flex; /* ensure it’s a flex item internally */
  flex-direction: row;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}
/* Ignore vertical for now, but keeping this won't hurt */
.FF_PreviewFields_checkboxGroup__isVertical_HEwfe .FF_PreviewFields_checkboxItem_ur-wF,
.FF_PreviewFields_radioGroup__isVertical_C\\+84u .FF_PreviewFields_radioItem_R\\+fJC {
  min-width: 100%;
  flex-basis: 100%;
}

/* ===========  SingleSelect / MultiSelect  ============= */
.FF_PreviewFields_singleSelect_XQzUU,
.FF_PreviewFields_multiSelect_Yzby6 {
  width: 100%;
}
.FF_PreviewFields_singleSelectDropdown_-F2qP,
.FF_PreviewFields_multiSelectDropdown_zrcKP {
  max-height: 20rem;
  z-index: 1350;
}

/* ===========  Spacer  ============= */
.FF_PreviewFields_spacer_TrJUB {
  width: 100%;
  display: block;
}

/* ===========  Boolean Switch  ============= */
.FF_PreviewFields_booleanSwitch_p4omJ {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}
.FF_PreviewFields_booleanSwitchControl_nsAU8 {
  width: min-content;
}

/* ===========  Password  ============= */
.FF_PreviewFields_password_\\+l-QT {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  width: 100%;
}
.FF_PreviewFields_passwordFieldWrapper_YnfjX {
  flex: 1 1 0;
  min-width: 0;
}

/* ===========  Sensitive  ============= */
.FF_PreviewFields_datePickerRoot_-UehA {
  width: 100%;
}

/* ===========  Sensitive  ============= */
.FF_PreviewFields_sensitiveFieldWrapper_8RLxj {
  width: 100%;
}

/* ===========  Terms and Conditions  ============= */
.FF_PreviewFields_termsAndConditions_EvNzH {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.FF_PreviewFields_termsAndConditionsCheckbox_6Pfkr {
  justify-content: flex-end;
  width: 100%;
  min-height: 3.125rem;
  height: auto;
}
.FF_PreviewFields_termsAndConditionsTermsTextWrapper_jv3G4 {
  width: 100%;
}
.FF_PreviewFields_tncMessage_eqGLq {
  display: inline;
}
/* Modal related T&C */
.FF_PreviewFields_termsAndConditionsModal_iwGaA {
  width: 50rem;
  max-width: calc(100vw - 4rem);
}
.FF_PreviewFields_termsAndConditionsBody_HQuD4 {
  display: flex;
  flex-direction: column;
  min-height: 22.5rem;
  padding: 1.5rem;
}
.FF_PreviewFields_termsAndConditionsBody_HQuD4 .SaviyntRenderQuillDelta .ql-editor {
  background: var(--color-background-neutral-subtlest, #fff);
  border-radius: var(--border-radius-xs, 0.25rem);
  padding: 1.5rem;
}
.FF_PreviewFields_termsAndConditionsEmptyDelta_DUUp4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: auto 0;
}
.FF_PreviewFields_termsAndConditionsHeader_9\\+9Ks {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem 1rem 1.5rem 3rem;
  background: var(--color-background-neutral-subtlest, #fff);
  border-bottom: 1px solid var(--color-border-neutral-decorative, #ebecf2);
  border-radius: var(--border-radius-xs, 0.25rem)
    var(--border-radius-xs, 0.25rem) 0 0;
}
.FF_PreviewFields_termsAndConditionsHeaderTitle_rITKr {
  margin: 0;
  color: var(--color-foreground-neutral-bold, #212328);
}
.FF_PreviewFields_termsAndConditionsFooter_8mWf7 {
  justify-content: flex-end;
  gap: 0.5rem;
}

/* Mobile drawer variant (ModalIsland isMobileWidth) */
@media (max-width: 599px) {
  .FF_PreviewFields_termsAndConditionsModal_iwGaA {
    width: 100vw;
    max-width: 100vw;
  }
  .FF_PreviewFields_termsAndConditionsHeader_9\\+9Ks {
    padding: 1rem 1rem 1rem 1.5rem;
    border-radius: 0;
    border-bottom: none;
    background: transparent;
  }
  .FF_PreviewFields_termsAndConditionsBody_HQuD4 {
    min-height: 50vh;
    max-height: none;
    padding: 0;
    background: transparent;
  }
  .FF_PreviewFields_termsAndConditionsBody_HQuD4
    .SaviyntRenderQuillDelta
    .ql-editor {
    background: transparent;
    border-radius: 0;
    padding: 1.5rem;
  }
}

/* ===========  Captcha  ============= */
.FF_PreviewFields_captcha_6qCvt {
  position: relative;
  display: block;
  width: 100%;
  min-height: 4.5rem;
}
.FF_PreviewFields_captchaWidgetOverlay_IRsZ8 {
  position: absolute;
  inset: 0;
}

/* ===========  Read-Only Field Value  ============= */
.FF_PreviewFields_value__isReadOnly_j9oCG:disabled {
  color: var(--color-foreground-neutral-medium, #4a4c59);
}

/* MenuInput responsive heights -- Breakpoint Vars are not working for the heights */
@media (max-height: 899px) {
  .FF_PreviewFields_singleSelectDropdown_-F2qP,
  .FF_PreviewFields_multiSelectDropdown_zrcKP {
    max-height: 16rem;
  }
}
/* @media (max-height: 767px) {
  .singleSelectDropdown,
  .multiSelectDropdown {
    max-height: 10rem;
  }
}
@media (max-height: 599px) {
  .singleSelectDropdown,
  .multiSelectDropdown {
    max-height: 6.75rem;
  }
} */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `FF_PreviewFields_checkbox_eYWMz`,
	"radio": `FF_PreviewFields_radio_YRSyy`,
	"checkboxGroup": `FF_PreviewFields_checkboxGroup_C1uVH`,
	"radioGroup": `FF_PreviewFields_radioGroup_5gJMz`,
	"checkboxGroup__isHorizontal": `FF_PreviewFields_checkboxGroup__isHorizontal_fcAfz`,
	"checkboxItem": `FF_PreviewFields_checkboxItem_ur-wF`,
	"radioGroup__isHorizontal": `FF_PreviewFields_radioGroup__isHorizontal_spbRz`,
	"radioItem": `FF_PreviewFields_radioItem_R+fJC`,
	"checkboxGroup__isVertical": `FF_PreviewFields_checkboxGroup__isVertical_HEwfe`,
	"radioGroup__isVertical": `FF_PreviewFields_radioGroup__isVertical_C+84u`,
	"singleSelect": `FF_PreviewFields_singleSelect_XQzUU`,
	"multiSelect": `FF_PreviewFields_multiSelect_Yzby6`,
	"singleSelectDropdown": `FF_PreviewFields_singleSelectDropdown_-F2qP`,
	"multiSelectDropdown": `FF_PreviewFields_multiSelectDropdown_zrcKP`,
	"spacer": `FF_PreviewFields_spacer_TrJUB`,
	"booleanSwitch": `FF_PreviewFields_booleanSwitch_p4omJ`,
	"booleanSwitchControl": `FF_PreviewFields_booleanSwitchControl_nsAU8`,
	"password": `FF_PreviewFields_password_+l-QT`,
	"passwordFieldWrapper": `FF_PreviewFields_passwordFieldWrapper_YnfjX`,
	"datePickerRoot": `FF_PreviewFields_datePickerRoot_-UehA`,
	"sensitiveFieldWrapper": `FF_PreviewFields_sensitiveFieldWrapper_8RLxj`,
	"termsAndConditions": `FF_PreviewFields_termsAndConditions_EvNzH`,
	"termsAndConditionsCheckbox": `FF_PreviewFields_termsAndConditionsCheckbox_6Pfkr`,
	"termsAndConditionsTermsTextWrapper": `FF_PreviewFields_termsAndConditionsTermsTextWrapper_jv3G4`,
	"tncMessage": `FF_PreviewFields_tncMessage_eqGLq`,
	"termsAndConditionsModal": `FF_PreviewFields_termsAndConditionsModal_iwGaA`,
	"termsAndConditionsBody": `FF_PreviewFields_termsAndConditionsBody_HQuD4`,
	"termsAndConditionsEmptyDelta": `FF_PreviewFields_termsAndConditionsEmptyDelta_DUUp4`,
	"termsAndConditionsHeader": `FF_PreviewFields_termsAndConditionsHeader_9+9Ks`,
	"termsAndConditionsHeaderTitle": `FF_PreviewFields_termsAndConditionsHeaderTitle_rITKr`,
	"termsAndConditionsFooter": `FF_PreviewFields_termsAndConditionsFooter_8mWf7`,
	"captcha": `FF_PreviewFields_captcha_6qCvt`,
	"captchaWidgetOverlay": `FF_PreviewFields_captchaWidgetOverlay_IRsZ8`,
	"value__isReadOnly": `FF_PreviewFields_value__isReadOnly_j9oCG`
};
export default ___CSS_LOADER_EXPORT___;
